import { render, staticRenderFns } from "./ConsultarPontosForm.vue?vue&type=template&id=2b6c857c&scoped=true"
import script from "./ConsultarPontosForm.vue?vue&type=script&lang=js"
export * from "./ConsultarPontosForm.vue?vue&type=script&lang=js"
import style0 from "./ConsultarPontosForm.vue?vue&type=style&index=0&id=2b6c857c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6c857c",
  null
  
)

export default component.exports